import React from "react";
import styled from "styled-components";

const G = styled.g`
  stroke: ${props =>
    props.selected ? props.theme.iconInner : props.theme.icon};
  fill: ${props => (props.selected ? props.theme.icon : "none")};
`;

const HomeIcon = ({ selected }) => {
  if (window.innerWidth > 1800) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
      >
        <G
          selected={selected}
          transform="translate(1 1)"
          fill="none"
          strokeWidth="2"
        >
          <rect
            width="15"
            height="30"
            transform="translate(15)"
            strokeMiterlimit="10"
          />
          <path d="M0,0H15V20H0Z" transform="translate(0 10)" />
          <line x2="7" transform="translate(19.5 12.5)" strokeMiterlimit="10" />
          <line x2="7" transform="translate(4.5 17.5)" strokeMiterlimit="10" />
          <line x2="7" transform="translate(4.5 23.5)" strokeMiterlimit="10" />
          <line x2="7" transform="translate(19.5 5.5)" strokeMiterlimit="10" />
          <line x2="7" transform="translate(19.5 19.5)" strokeMiterlimit="10" />
        </G>
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18.524"
        height="18.524"
        viewBox="0 0 18.524 18.524"
      >
        <G selected={selected} transform="translate(-18.5 -388.634)">
          <rect
            width="8.762"
            height="17.524"
            transform="translate(27.762 389.134)"
            strokeMiterlimit="10"
          />
          <path d="M0,0H8.762V11.683H0Z" transform="translate(19 394.976)" />
          <line
            x2="4.089"
            transform="translate(30.391 396.436)"
            strokeMiterlimit="10"
          />
          <line
            x2="4.089"
            transform="translate(21.629 399.357)"
            strokeMiterlimit="10"
          />
          <line
            x2="4.089"
            transform="translate(21.629 403.446)"
            strokeMiterlimit="10"
          />
          <line
            x2="4.089"
            transform="translate(30.391 392.347)"
            strokeMiterlimit="10"
          />
          <line
            x2="4.089"
            transform="translate(30.391 400.525)"
            strokeMiterlimit="10"
          />
        </G>
      </svg>
    );
  }
};

export default HomeIcon;
